import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import {
    GET_REASSIGN_OVERRIDE_USERS_SUCCESS,
    GET_REASSIGN_OVERRIDE_USERS_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const getNodeText = (parentNode, selector) => {
    const node = parentNode?.querySelector(selector);
    return node?.textContent?.trim() || '';
};

const parseReassignUsersResponse = (response) => {
    if (!response || typeof response !== 'string') {
        return response;
    }

    try {
        const parser = new DOMParser();
        const xmlDocument = parser.parseFromString(response, 'application/xml');
        const parserError = xmlDocument.querySelector('parsererror');

        if (parserError) {
            return response;
        }

        const usersList = Array.from(xmlDocument.querySelectorAll('usersWSDTO > usersList')).map((userNode) => ({
            firstName: getNodeText(userNode, 'firstName'),
            lastName: getNodeText(userNode, 'lastName'),
            networkId: getNodeText(userNode, 'networkId'),
            uid: getNodeText(userNode, 'uid'),
        }));

        return {
            statusCode: getNodeText(xmlDocument, 'usersWSDTO > statusCode'),
            statusMessage: getNodeText(xmlDocument, 'usersWSDTO > statusMessage'),
            usersList,
        };
    } catch (error) {
        return response;
    }
};

export function* getReassignOverrideUsersData(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const url = `/occ/v2/${baseSiteId}/priceOverride/reassignusers`;
    const { myCaseRef = '', searchParam = '' } = action.payload || {};

    try {
        const response = yield axios
            .get(url, {
                params: { myCaseRef, ...(searchParam ? { searchParam } : {}) },
                headers: {
                    accept: 'application/xml',
                },
            })
            .then((res) => res.data);

        yield put({ type: GET_REASSIGN_OVERRIDE_USERS_SUCCESS, data: parseReassignUsersResponse(response) });
    } catch (error) {
        yield put({
            type: GET_REASSIGN_OVERRIDE_USERS_FAILURE,
            data: { statusCode: error?.response?.status, statusMessage: error?.message },
        });
        errorHandler(error);
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: { myCaseRef },
        });
    }
}